import loadable from '@loadable/component';

export const CompensationSurveyLoadable = loadable(
  () => import('./CompensationSurvey'),
  { resolveComponent: (module) => module.CompensationSurvey },
);
